import firebase from 'firebase';
import * as Firebase from '../config.js';

export default {
  store(note){

  },

  get(name){
    return Firebase.notes.child(name).once('value');
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Note.js